/**
 * Where the forms post, decided at build time rather than hardcoded in the
 * components.
 *
 * `scripts/deploy.mjs` reads `formsBackend` from deploy/targets.json and the
 * matching endpoint from deploy/functions.json, and exports both into the
 * build as GATSBY_ variables. A plain `yarn build` or `yarn dev` sets neither,
 * and falls through to the legacy API — which is exactly what the site did
 * before this file existed, so nothing changes for anyone building locally.
 */

/** Which backend this build talks to. See deploy/targets.json. */
export type FormsBackend = 'legacy' | 'dual' | 'native';

/**
 * The original API in account 249657377702. Still live, still the fallback,
 * and it stays deployed until the migration's final phase.
 */
const LEGACY_ENDPOINT =
  'https://tq32524cv2.execute-api.us-east-1.amazonaws.com/Production';

const configured = process.env.GATSBY_FORMS_ENDPOINT;
const mode = (process.env.GATSBY_FORMS_BACKEND ?? 'legacy') as FormsBackend;

export const FORMS_BACKEND: FormsBackend = mode;

/**
 * In "dual" the browser posts to the native endpoint and the intake function
 * forwards a copy to legacy — the forwarding is server-side on purpose, so a
 * slow or failing legacy API can never delay or fail a submission that is
 * already durable.
 */
export const FORMS_ENDPOINT: string =
  mode === 'legacy' || !configured ? LEGACY_ENDPOINT : configured;

/** The wording a subscriber agrees to, recorded with their consent. */
export const CONSENT_TEXT =
  'I would like to receive news about exhibitions and works from Kumar Gallery.';
